import styles from './index.module.scss';

const MultilineLoading = ({ lines }: { lines: number }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {Array.from({ length: lines }).map((_, index) => (
        <div key={index} className={styles['loadingRow']} />
      ))}
    </div>
  );
};

export default MultilineLoading;
